(function () {
  angular.module("akitabox.dashboard", ["akitabox.main"]);
})();
